export {
  moveVirtualFocus,
  dispatchVirtualBlur,
  dispatchVirtualFocus,
  getVirtuallyFocusedElement
} from '../../../src/focus/virtualFocus';
